<div fxLayout="column" fxFlexFill>
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" [multiTemplateDataRows]="true" class="regular-table responsive"
               matSort matSortActive="account" matSortDirection="desc" matSortDisableClear>
      <ng-container matColumnDef="account">
        <mat-header-cell *matHeaderCellDef mat-sort-header="account">Account</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Account:</span>
          <a *ngIf="hasEditAccess" [routerLink]="[row.account]">
            {{ row.account }}
          </a>
          <span *ngIf="!hasEditAccess">{{ row.account }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="displayName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="displayName">Name</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Name:</span>
          {{ row.displayName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="ani">
        <mat-header-cell *matHeaderCellDef mat-sort-header="ani">Ani</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Ani:</span>
          <span *ngFor="let a of (row.ani || '').split(' '); let index = index"
                style="padding-right: 5px">
            {{a | phoneNumber}}{{index + 1 == (row.ani || '').split(' ').length ? '' : ','}}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="alias">
        <mat-header-cell *matHeaderCellDef mat-sort-header="alias">Alias</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Alias:</span>
          <span>
            <ng-container *ngFor="let a of (row.alias || []); let index = index">
              {{a | phoneNumber}}{{index + 1 == (row.alias || []).length ? '' : ','}}
            </ng-container>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="holidayDisplay">
        <mat-header-cell *matHeaderCellDef>Holidays</mat-header-cell>
        <mat-cell *matCellDef="let row" fxLayout="column" fxLayoutAlign="center start">
          <span class="mobile-label">Holidays:</span>
          <span>{{row.holidayDisplay | holidaysRange}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="audio">
        <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <div class="recordings-control">
            <button mat-stroked-button (click)="playRecording(row.holidayAccount)"
                    matTooltip="Play Holiday Greeting {{row.holidayAccount}}">
              Play <mat-icon>play_arrow</mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Status:</span>
          {{ row.status }}
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
  <div class="recordings-control-container">
    <app-audio-control #audioPlayer [src]="currentAudioSource"
                       [downloadSrc]="currentAudioDownloadSource"
                       [showDelete]="false"
                       [showDownload]="true"
                       [autoPlay]="true"
                       title="Holiday Greeting"
                       (errorEmitter)="onAudioError($event)"
    ></app-audio-control>
  </div>
</div>
